module.exports = __webpack_public_path__ + "media/img/ceo-phuc-12426ecb.jpg";